/* OverflowAvatarStack.tsx generated by @compiled/babel-plugin v0.38.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import "./OverflowAvatarStack.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { useIntl } from 'react-intl-next';
import AvatarGroup from '@atlaskit/avatar-group';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import Tooltip from '@atlaskit/tooltip';
import { useReportingLinesStore } from '@atlassian/teams';
import { useReportingLinesStore as DEPRECATED_useReportingLinesStore } from '../store';
import { messages } from './messages';
import * as Styled from './styles';
import { AccountIdentifierType } from './types';
var styles = {
  avatarGroupContainer: "_otyru2gc"
};
var appendMissingProfileStackItemData = function appendMissingProfileStackItemData(avatarData, numMissingProfiles, intl) {
  if (numMissingProfiles === 0) {
    return avatarData;
  }
  var name = intl.formatMessage(messages.MissingProfileName, {
    numMissingProfiles: numMissingProfiles
  });
  var label = intl.formatMessage(messages.MissingProfileTooltip, {
    name: name,
    numMissingProfiles: numMissingProfiles
  });
  return avatarData.concat([{
    name: name,
    label: label,
    href: '#',
    // Required otherwise tooltip doesn't render
    isDisabled: true
  }]);
};
var AVATAR_LIMIT = 6;
var AvatarGroupWrapper = function AvatarGroupWrapper(_ref) {
  var allUserAvatarData = _ref.allUserAvatarData,
    avatarSize = _ref.avatarSize,
    onAvatarClick = _ref.onAvatarClick;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.avatarGroupContainer
  }, /*#__PURE__*/React.createElement(AvatarGroup, {
    appearance: "stack",
    data: allUserAvatarData,
    maxCount: AVATAR_LIMIT,
    size: avatarSize,
    overrides: {
      Avatar: {
        // Adds tooltips on missing profile icon, ensures it shows up (by saying its not disabled)
        render: function render(Component, props, index) {
          return props.isDisabled ? /*#__PURE__*/React.createElement(Tooltip, {
            content: props.label
          }, /*#__PURE__*/React.createElement(Component, _extends({}, props, {
            key: props.name,
            isDisabled: false,
            href: undefined,
            onClick: function onClick(e) {
              return onAvatarClick(e, index);
            }
          }))) : /*#__PURE__*/React.createElement(Component, _extends({}, props, {
            href: undefined,
            onClick: function onClick(e) {
              return onAvatarClick(e, index);
            }
          }));
        }
      }
    }
  }));
};
export var OverflowAvatarStack = function OverflowAvatarStack(_ref2) {
  var atlassianUsers = _ref2.atlassianUsers,
    numFilteredMissingProfiles = _ref2.numFilteredMissingProfiles,
    avatarSize = _ref2.avatarSize,
    _ref2$includeNameInMo = _ref2.includeNameInMoreText,
    includeNameInMoreText = _ref2$includeNameInMo === void 0 ? false : _ref2$includeNameInMo,
    onStackClick = _ref2.onClick;
  var intl = useIntl();
  var _useReportingLinesSto = useReportingLinesStore(),
    _useReportingLinesSto2 = _slicedToArray(_useReportingLinesSto, 2),
    selectUser = _useReportingLinesSto2[1].selectUser;
  var _DEPRECATED_useReport = DEPRECATED_useReportingLinesStore(),
    _DEPRECATED_useReport2 = _slicedToArray(_DEPRECATED_useReport, 2),
    selectUserDEPRECATED = _DEPRECATED_useReport2[1].selectUser;
  var avatarsToShow = atlassianUsers.slice(0, AVATAR_LIMIT);
  var atlassianUsersAvatarGroupData = avatarsToShow.map(function (user) {
    var _user$pii, _user$pii$name, _user$pii2, _user$pii$extendedPro, _user$pii3, _user$pii$picture, _user$pii4;
    var isNotMissingProfile = !!((_user$pii = user.pii) !== null && _user$pii !== void 0 && _user$pii.name);
    var name = (_user$pii$name = (_user$pii2 = user.pii) === null || _user$pii2 === void 0 ? void 0 : _user$pii2.name) !== null && _user$pii$name !== void 0 ? _user$pii$name : intl.formatMessage(messages.MissingProfileName, {
      numMissingProfiles: 1
    });
    var jobTitle = (_user$pii$extendedPro = (_user$pii3 = user.pii) === null || _user$pii3 === void 0 || (_user$pii3 = _user$pii3.extendedProfile) === null || _user$pii3 === void 0 ? void 0 : _user$pii3.jobTitle) !== null && _user$pii$extendedPro !== void 0 ? _user$pii$extendedPro : undefined;
    var label = isNotMissingProfile ? "".concat(name).concat(jobTitle ? " (".concat(jobTitle, ")") : '') : intl.formatMessage(messages.MissingProfileTooltip, {
      name: name,
      numMissingProfiles: 1
    });
    return {
      name: name,
      src: (_user$pii$picture = (_user$pii4 = user.pii) === null || _user$pii4 === void 0 ? void 0 : _user$pii4.picture) !== null && _user$pii$picture !== void 0 ? _user$pii$picture : undefined,
      href: user.identifierType === AccountIdentifierType.ATLASSIAN_ID && user.accountIdentifier || undefined,
      label: label
    };
  });

  // Append an avatar as a placeholder for missing profiles when there is space to show it
  var allUserAvatarData = atlassianUsersAvatarGroupData.length < AVATAR_LIMIT ? appendMissingProfileStackItemData(atlassianUsersAvatarGroupData, numFilteredMissingProfiles, intl) : atlassianUsersAvatarGroupData;
  var onAvatarClick = function onAvatarClick(e, index) {
    var _atlassianUsers$index;
    e.stopPropagation();
    e.preventDefault();
    var identifier = (_atlassianUsers$index = atlassianUsers[index]) === null || _atlassianUsers$index === void 0 ? void 0 : _atlassianUsers$index.accountIdentifier;
    if (identifier) {
      if (fg('ptc-consume-reporting-lines')) {
        selectUser(identifier);
      } else {
        selectUserDEPRECATED(identifier);
      }
    }
  };
  var numUsers = atlassianUsers.length + numFilteredMissingProfiles;
  // Reduce by 1 because we're rendering one of them with their full name instead
  var restCount = includeNameInMoreText ? numUsers - 1 : numUsers;
  return fg('remove_nested_elements_reporting_lines') ? /*#__PURE__*/React.createElement(Inline, {
    space: "space.050",
    alignBlock: "center",
    alignInline: "center"
  }, /*#__PURE__*/React.createElement(AvatarGroupWrapper, {
    allUserAvatarData: allUserAvatarData,
    avatarSize: avatarSize,
    onAvatarClick: onAvatarClick
  }), /*#__PURE__*/React.createElement(Styled.OverflowStackCard, {
    onClick: onStackClick,
    onKeyDown: function onKeyDown(_ref3) {
      var key = _ref3.key;
      if (key === 'Enter' || key === ' ') {
        onStackClick();
      }
    }
  }, /*#__PURE__*/React.createElement(Styled.OverflowStackMoreText, null, intl.formatMessage(includeNameInMoreText ? messages.OverflowAvatarStackShowMore : messages.OverflowAvatarStackMore, {
    numUsers: numUsers
  })))) : /*#__PURE__*/React.createElement(Styled.OverflowStackCard, {
    onClick: onStackClick,
    onKeyDown: function onKeyDown(_ref4) {
      var key = _ref4.key;
      if (key === 'Enter' || key === ' ') {
        onStackClick();
      }
    }
  }, /*#__PURE__*/React.createElement(AvatarGroup, {
    appearance: "stack",
    data: allUserAvatarData,
    maxCount: AVATAR_LIMIT,
    size: avatarSize,
    overrides: {
      Avatar: {
        // Adds tooltips on missing profile icon, ensures it shows up (by saying its not disabled)
        render: function render(Component, props, index) {
          return props.isDisabled ? /*#__PURE__*/React.createElement(Tooltip, {
            content: props.label
          }, /*#__PURE__*/React.createElement(Component, _extends({}, props, {
            key: props.name,
            isDisabled: false,
            href: undefined,
            onClick: function onClick(e) {
              return onAvatarClick(e, index);
            }
          }))) : /*#__PURE__*/React.createElement(Component, _extends({}, props, {
            href: undefined,
            onClick: function onClick(e) {
              return onAvatarClick(e, index);
            }
          }));
        }
      }
    }
  }), /*#__PURE__*/React.createElement(Styled.OverflowStackMoreText, null, includeNameInMoreText ? /*#__PURE__*/React.createElement(Styled.OverflowStackUserName, null, allUserAvatarData[0].name) : null, /*#__PURE__*/React.createElement("div", null, includeNameInMoreText && /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0+\xA0"), intl.formatMessage(messages.OverflowAvatarStackMore, {
    numUsers: restCount
  }))));
};